import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBadge, MDBIcon, MDBView } from "mdbreact";
import { Services } from "../../../../../services/fakeDb";
import {
  SetSERVICES,
  SetFILTERED,
} from "../../../../../services/redux/slices/commerce/catalog/services";
import { BROWSE as BROWSE_MENUS } from "../../../../../services/redux/slices/commerce/catalog/menus";
import { DEPARTMENTS, getTemplates, useServiceMenus } from "./utils";

// every word must be found in one of the fields a cashier would search by
const matches = (service, key) => {
  const text = [
    service.name,
    service.abbreviation,
    service.specimen,
    service.purpose,
    service.ssx,
    ...(Array.isArray(service.organ) ? service.organ : []),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return key
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => text.includes(word));
};

const Header = () => {
  const { maxPage, token, activePlatform } = useSelector(({ auth }) => auth),
    { collections, filtered } = useSelector(({ services }) => services),
    [search, setSearch] = useState(""),
    [department, setDepartment] = useState(""),
    [template, setTemplate] = useState(""),
    [offeredOnly, setOfferedOnly] = useState(false),
    menusOf = useServiceMenus(),
    dispatch = useDispatch();

  //initial values
  useEffect(() => {
    dispatch(SetSERVICES({ collections: Services.collections, maxPage }));
  }, [dispatch, maxPage]);

  // the menus tell which services are sold here and for how much
  useEffect(() => {
    if (token && activePlatform?.branchId)
      dispatch(
        BROWSE_MENUS({ token, key: { branchId: activePlatform.branchId } }),
      );
  }, [token, activePlatform, dispatch]);

  const counts = useMemo(() => {
    const byDepartment = {};
    collections.forEach(({ department: d }) => {
      byDepartment[d] = (byDepartment[d] || 0) + 1;
    });
    return byDepartment;
  }, [collections]);

  useEffect(() => {
    const key = search.trim();
    dispatch(
      SetFILTERED(
        collections.filter(
          (service) =>
            (!department || service.department === department) &&
            (template === "" || service.template === Number(template)) &&
            (!offeredOnly || menusOf.has(Number(service.id))) &&
            (!key || matches(service, key)),
        ),
      ),
    );
  }, [collections, search, department, template, offeredOnly, menusOf, dispatch]);

  const templates = department ? getTemplates(department) : [];

  return (
    <>
      <MDBView
        cascade
        className="gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
      >
        <span className="white-text mx-3 text-nowrap mt-0">
          {filtered.length === collections.length
            ? `${collections.length} Services`
            : `${filtered.length} of ${collections.length} Services`}
        </span>
        <div className="position-relative mr-2" style={{ width: "22rem" }}>
          <MDBIcon
            icon="search"
            className="position-absolute text-muted"
            style={{ top: "50%", left: 12, transform: "translateY(-50%)" }}
          />
          <input
            className="form-control form-control-sm"
            style={{ paddingLeft: 34 }}
            placeholder="Search name, abbreviation, specimen, organ, symptom..."
            value={search}
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>
      </MDBView>

      <div className="d-flex flex-wrap align-items-center justify-content-between mx-4 mb-2">
        <div className="d-flex flex-wrap align-items-center">
          {[{ value: "", text: "All" }, ...DEPARTMENTS].map(
            ({ value, text }) => {
              const count = value ? counts[value] || 0 : collections.length;
              if (value && !count) return null;
              const isActive = department === value;
              return (
                <button
                  key={value || "all"}
                  type="button"
                  className={`btn btn-sm m-0 mr-2 mb-1 px-3 ${
                    isActive ? "btn-info" : "btn-outline-info"
                  }`}
                  onClick={() => {
                    setDepartment(value);
                    setTemplate("");
                  }}
                >
                  {text}
                  <MDBBadge
                    color={isActive ? "light" : "info"}
                    className="ml-2"
                    pill
                  >
                    {count}
                  </MDBBadge>
                </button>
              );
            },
          )}
        </div>
        <div className="d-flex align-items-center mb-1">
          {templates.length > 0 && (
            <select
              className="form-control form-control-sm mr-3"
              style={{ width: "13rem" }}
              value={template}
              onChange={({ target }) => setTemplate(target.value)}
            >
              <option value="">All sections</option>
              {templates.map((name, index) => (
                <option key={name} value={index}>
                  {name}
                </option>
              ))}
            </select>
          )}
          <div className="custom-control custom-checkbox text-nowrap">
            <input
              type="checkbox"
              className="custom-control-input"
              id="services-offeredOnly"
              checked={offeredOnly}
              onChange={({ target }) => setOfferedOnly(target.checked)}
            />
            <label
              className="custom-control-label small"
              htmlFor="services-offeredOnly"
              title="Services included in at least one menu of this branch"
            >
              Offered here only
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
